import axios, { AxiosInstance } from 'axios';
import { API_URL } from '@/shared/constants/strings';
import {
  CANDIDATO_ACCESS_TOKEN_HEADER,
  CANDIDATO_TOKEN_KEY,
  DEFENSOR_TOKEN_KEY,
  getCandidatoAccessToken,
} from './candidato.constants';
import { Endpoints } from '@/shared/constants/endpoints';

/** Cliente axios só para GET em blob com token do candidato (ou fallback admin). */
function createCandidatoBlobClient(candidatoId?: number | null): AxiosInstance {
  const client = axios.create({ baseURL: API_URL as string });
  client.interceptors.request.use((config) => {
    const token =
      localStorage.getItem(CANDIDATO_TOKEN_KEY) || localStorage.getItem(DEFENSOR_TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (candidatoId) {
      const accessToken = getCandidatoAccessToken(candidatoId);
      if (accessToken) {
        config.headers[CANDIDATO_ACCESS_TOKEN_HEADER] = accessToken;
      }
    }
    if (!(config.data instanceof FormData)) {
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    return config;
  });
  return client;
}

function baixarBlob(blob: Blob, nomeArquivo: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', nomeArquivo);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export async function baixarArquivoCandidato(
  fileId: string,
  nomeExibicao: string,
  candidatoId?: number | null,
): Promise<void> {
  const client = createCandidatoBlobClient(candidatoId);
  const response = await client.get(Endpoints.CANDIDATO + '/file/' + fileId, {
    responseType: 'blob',
  });
  baixarBlob(new Blob([response.data]), nomeExibicao || 'arquivo.pdf');
}

export async function abrirPdfCandidatoNovaAba(
  fileId: string,
  candidatoId?: number | null,
): Promise<void> {
  const client = createCandidatoBlobClient(candidatoId);
  const response = await client.get(Endpoints.CANDIDATO + '/file/' + fileId, {
    responseType: 'blob',
  });
  const url = window.URL.createObjectURL(
    new Blob([response.data], { type: 'application/pdf' }),
  );
  window.open(url, '_blank');
}

export async function baixarProvaProcessoSeletivoPublica(
  processoSeletivoId: number,
): Promise<void> {
  const response = await axios.get(
    `${API_URL}${Endpoints.PROCESSO_SELETIVO}/prova/file/${processoSeletivoId}`,
    { responseType: 'blob' },
  );
  baixarBlob(new Blob([response.data]), 'prova.pdf');
}
